import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LowBatteryDetails from "./LowBatteryDetails";
import PropTypes from "prop-types";

const ChatArea = ({ className = "" }) => {
  const navigate = useNavigate();

  const onGroupContainerClick = useCallback(() => {
    navigate("/42-edit-profile");
  }, [navigate]);

  const onHngDnSClick = useCallback(() => {
    navigate("/6-introduction");
  }, [navigate]);

  return (
    <div
      className={`self-stretch flex flex-col items-start justify-start gap-[15px] max-w-full text-left text-21xl text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex flex-row items-end justify-start gap-[3px]">
        <div
          className="flex flex-row items-start justify-start cursor-pointer"
          onClick={onGroupContainerClick}
        >
          <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
            Chào Nam
          </h1>
        </div>
        <div className="flex flex-col items-start justify-end pt-0 px-0 pb-2">
          <img
            className="w-6 h-6 relative overflow-hidden shrink-0"
            loading="lazy"
            alt=""
            src="/mode-edit-outline.svg"
          />
        </div>
      </div>
      <div className="self-stretch flex flex-col items-start justify-start gap-[65px] max-w-full text-center text-base text-light-text mq330:gap-8">
        <h3 className="m-0 relative text-5xl font-semibold font-[inherit] text-left inline-block max-w-full">
          Máy của bé My sắp hết pin!
        </h3>
        <div className="self-stretch flex flex-col items-start justify-start pt-0 px-0 pb-[7px] box-border gap-10 max-w-full mq330:gap-5">
          <LowBatteryDetails
            lowBatteryDetailsBackgroundColor="#ffeaf7"
            lowBatteryDetailsPadding="22px 20px"
            rectangleDivBackgroundColor="#ffeaf7"
            device12LowBattery1="/chatgpt-image-13-29-24-5-thg-4-2025-1@2x.png"
            lastInteractionPadding="0px 0px 9px"
            myCaBMy="Máy của bé My"
            cuTLnCui="2000 câu từ lần cuối"
            blankLineColor="#565656"
            pin18FontFamily="'Be Vietnam Pro'"
            pin18FontSize="10px"
            blankLineFontFamily="'Be Vietnam Pro'"
            blankLineFontSize="10px"
            cuTLnCuiFontFamily="'Be Vietnam Pro'"
            xemLchSFontSize="10px"
            xemLchSFontFamily="'Be Vietnam Pro'"
          />
          <LowBatteryDetails
            lowBatteryDetailsBackgroundColor="#fff2ea"
            lowBatteryDetailsPadding="21px 20px 23px"
            rectangleDivBackgroundColor="#fff2ea"
            device12LowBattery1="/device-2-1@2x.png"
            lastInteractionPadding="0px 0px 8px"
            myCaBMy="Máy mới cho Hùng"
            cuTLnCui="Hôm nay chưa nói"
            blankLineColor="#565656"
            pin18FontFamily="'Be Vietnam Pro'"
            pin18FontSize="10px"
            blankLineFontFamily="'Be Vietnam Pro'"
            blankLineFontSize="10px"
            cuTLnCuiFontFamily="'Be Vietnam Pro'"
            xemLchSFontSize="10px"
            xemLchSFontFamily="'Be Vietnam Pro'"
          />
          <div className="self-stretch flex flex-row items-start justify-start py-0 pl-[98px] pr-[107px] mq330:pl-5 mq330:pr-5 mq330:box-border">
            <div className="relative font-medium whitespace-pre-wrap">
              + Thêm thiết bị mới
            </div>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-start justify-start py-0 pl-[99px] pr-[109px] mq330:pl-5 mq330:pr-5 mq330:box-border">
          <div
            className="w-[152px] relative font-semibold text-transparent !bg-clip-text [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] inline-block cursor-pointer"
            onClick={onHngDnSClick}
          >
            Hướng dẫn sử dụng
          </div>
        </div>
      </div>
    </div>
  );
};

ChatArea.propTypes = {
  className: PropTypes.string,
};

export default ChatArea;
